import axios from 'axios'
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { getToken } from '../user/User'

export const useStatus = (id) => {
    const [name, setName] = useState("")
    const [remindTimeInDays, setRemindTimeInDays] = useState(0)

    useEffect(() => {
        if(id !== null && id !== undefined) {
            const abortCont = new AbortController()
            
            axios.get(process.env.REACT_APP_API_URL + "/api/status/" + id, {
                signal: abortCont.signal,
                headers: {
                    "Authorization": "Bearer " + getToken()
                }
            })
            .then(res => {
                var data = res.data

                setName(data.name)
                setRemindTimeInDays(data.remind_time_in_days)
            }).catch(err => {
                if(err.message === "canceled") {
                    return
                }
                toast.error("Internal error")
            })
        
            return () => abortCont.abort()
        }
    }, [id])

    return { 
        id,
        name, setName,
        remindTimeInDays, setRemindTimeInDays,
    }
}